<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>In memory of those U.S. soldiers lost in the War Against Terrorism</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?307ce25e